// Transform modifiedSweeps to MP sweep structure
export const transformModifiedNavigationSweeps = (res) => {
  const sweeps = [];
  res.forEach((s) => {
    sweeps.push({
      uuid: s.uuid, // Not used
      sid: `${s.id}`, // Not used
      id: `${s.id}`, // Treedis sweep uuid
      sweepId: s.sweepId, // MP sweep uuid
      enabled: s.enabled,
      alignmentType: 'aligned',
      isCustom: s.isCustom,
      neighbors: s.neighbourSweeps,
      position: {
        x: s.positionX,
        y: s.isCustom ? s.positionY + 1.15 : s.positionY,
        z: s.positionZ,
      },
      rotation: {
        x: 0,
        y: 0,
        z: 0,
      },
      floorInfo: {
        id: s.floor,
        sequence: s.floor,
      },
      sweep_uuid: s.uuid,
      floor_index: s.floor,
      floor_position: {
        x: 0,
        y: 0,
        z: 0,
      },
    });
  });
  return sweeps;
};
